import { MenuList, Box } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontWeight, TypographyStyledGlobal } from '../../../theme';
import {
    ArrowDropUpIconStyled,
    ArrowDropDownIconStyled,
    MenuItemsStyled,
    DividerMenuStyled,
} from '../../../theme/style';
import { ButtonDropdownStyled, MenuDropdownStyled } from './styled';

interface DropdownTranslateMenuProps {
    selectedLanguageId: number;
    tenantLanguages: any[];
    handleLanguageChange: (languageId: number) => void;
}

const DropdownTranslateMenu: FC<DropdownTranslateMenuProps> = ({ selectedLanguageId, tenantLanguages, handleLanguageChange }) => {
    const [openDropdownMenu, setOpenDropdownMenu] = useState<boolean>(false);
    const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
    const { t } = useTranslation('navigation');

    const handleChangeStatusMenu = (event: React.MouseEvent<HTMLElement>) => {
        setOpenDropdownMenu(!openDropdownMenu);
        setAnchorElNav(event.currentTarget);
    };

    return (
        <ButtonDropdownStyled
            endIcon={openDropdownMenu ? <ArrowDropUpIconStyled /> : <ArrowDropDownIconStyled />}
            menuopen={openDropdownMenu ? 1 : 0}
            onClick={handleChangeStatusMenu}
            disableRipple
        >
            <Box sx={{ display: 'flex', width: '100%' }}>
                <TypographyStyledGlobal
                    color={colors.grey200}
                    margin="auto auto auto 8px"
                    weight='500'
                >
                    {t('translate')}
                </TypographyStyledGlobal>
            </Box>

            <MenuDropdownStyled
                anchorEl={anchorElNav}
                open={openDropdownMenu}
            >
                <MenuList sx={{ padding: 0 }}>
                    {tenantLanguages && tenantLanguages.map((tenantLanguage) => (
                        <MenuItemsStyled key={tenantLanguage.id} $isSelected={tenantLanguage.id === selectedLanguageId} onClick={() => handleLanguageChange(tenantLanguage.id)} disableRipple>
                            <TypographyStyledGlobal
                                textAlign="center"
                                weight={fontWeight.semiRegular}
                            >
                                {tenantLanguage.label}
                            </TypographyStyledGlobal>
                        </MenuItemsStyled>
                    ))}
                    <DividerMenuStyled sx={{ display: 'none' }} />
                </MenuList>
            </MenuDropdownStyled>
        </ButtonDropdownStyled>
    );
};

export default DropdownTranslateMenu;
